import * as auth from './auth';
import * as React from 'react';
import { runPortal } from '@piral/portal-core';
import { Footer } from './components/Footer';

const apiUrl = process.env.FEED_API_URL || 'https://feed.dev.piral.cloud';
const portalUrl = process.env.PORTAL_URL || 'http://localhost:1234';
const pages = {
  Login: React.lazy(() => import('./components/Teaser')),
  Privacy: React.lazy(() => import('./components/Privacy')),
  Terms: React.lazy(() => import('./components/Terms')),
  Imprint: React.lazy(() => import('./components/Imprint')),
};

const instance = await runPortal({
  apiUrl,
  portalUrl,
  auth,
  plans: ['free', 'premium'],
  landingPages: {
    '/': pages.Login,
  },
  consent: true,
  portalPages: {
    '/privacy': pages.Privacy,
    '/terms': pages.Terms,
    '/imprint': pages.Imprint,
  },
});

instance.root.registerExtension('layout-footer', Footer);
